import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'
import ReactStringReplace from 'react-string-replace'

class InformationDetail extends Component {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false, id: '', informationDetail: []}
  }
  componentWillMount () {
    this.loadInformationDetail()
  }
  loadInformationDetail () {
    const onSuccess = (res) => {
      const {params} = this.props.match
      const id = params.id
      const info = res.body.data.systemSettingValue.filter((e) => e.id === id)[0]
      this.setState({
        isLoaded: true,
        id: id,
        informationDetail: info
      })
    }
    const params = {
      command: 'get',
      systemSettingName: 'InformationSetting'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  deleteInformation () {
    const {params} = this.props.match
    const id = params.id
    const onSuccessToGet = (res) => {
      const systemSettingValue =
        res.body.data.systemSettingValue.filter((e) => e.id !== id)
      const sorter = (a, b) => {
        const dateA = a.year * 100000000 + a.month * 1000000 + a.day * 10000 + a.hour * 100 + a.minutes
        const dateB = b.year * 100000000 + b.month * 1000000 + b.day * 10000 + b.hour * 100 + b.minutes
        if (dateA < dateB) return 1
        if (dateA > dateB) return -1
        return 0
      }
      const paramsToSet = {
        command: 'set',
        systemSettingName: 'InformationSetting',
        systemSettingValue: systemSettingValue.sort(sorter)
      }
      const onSuccessToPost = (res) => {
        Window.alert('削除処理を実行しました', () => {
          this.props.history.push('/' + this.userRoleUrl + '/information/')
          Window.closeDialog()
        })
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
    }
    const paramsToGet = {
      command: 'get',
      systemSettingName: 'InformationSetting'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToGet, onSuccessToGet)
  }
  onPageMenuClicked (name) {
    const id = this.state.informationDetail.id
    switch (name) {
      case 'back':
        this.props.history.push('/' + this.userRoleUrl + '/information/')
        break
      case 'edit':
        this.props.history.push('/' + this.userRoleUrl + '/information/edit/' + id)
        break
      case 'delete':
        Window.confirm('本当に削除処理を実行しますか?', () => {
          this.deleteInformation()
        })
        break
      default:
        break
    }
  }
  convHttpLink (text) {
    const regExp = /(https?:\/\/\S+)/g
    return ReactStringReplace(text, regExp, (match, i) => (
      <a key={text} href={match} target='_blank'>{match}</a>
    ))
  }
  renderInformationDetail () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const info = this.state.informationDetail
    return (
      <fieldset>
        <legend>事務局からのお知らせ - 詳細</legend>
        <br />
        <div className='control-group row'>
          <label className='span3'>公開日</label>
          <div className='span13'>
            {info.year} / {info.month} / {info.day}
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>公開時刻</label>
          <div className='span13 row'>
            {info.hour}<span className='kw-info-unit'>時</span>
            {info.minutes}<span className='kw-info-unit'>分</span>
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>お知らせ</label>
          <div className='span13'>
            {this.convHttpLink(this.nl2br(info.body))}
          </div>
        </div>
      </fieldset>
    )
  }
  nl2br (text) {
    if (!(typeof (text) === 'string' || text instanceof String)) return
    const regex = /(\n)/g
    return text.split(regex).map(function (line, index) {
      if (line.match(regex)) {
        return React.createElement('br', { key: index })
      } else {
        return line
      }
    })
  }
  render () {
    const informationDetail = this.renderInformationDetail()
    const editButton = this.isShowingEditButton
      ? (
        <li className='kw-btn-area'>
          <button id='edit-button' rel='tooltip' title='編集' data-placement='bottom' className='kw-btn-success' onClick={(e) => this.onPageMenuClicked('edit', e)} >
            <i className='icon-edit icon-large' /><span>編集</span>
          </button>
        </li>
      )
      : ''
    const deleteButton = this.isShowingDeleteButton
      ? (
        <li key='ban' className='kw-btn-area'>
          <button id='delete-button' rel='tooltip' title='削除' data-placement='bottom' className='kw-btn-danger' onClick={(e) => this.onPageMenuClicked('delete', e)} >
            <i className='icon-remove icon-large' /><span>削除</span>
          </button>
        </li>
      )
      : ''
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>事務局からのお知らせ - 詳細<br />
                    <small>こちらで事務局からのお知らせを確認できます。</small>
                  </h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                  {editButton}
                  {deleteButton}
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container form-horizontal'>
          {informationDetail}
        </section>
      </div>
    )
  }
}

export default InformationDetail



// WEBPACK FOOTER //
// ./src/common/pages/secure/InformationDetail.js